import PropTypes from 'prop-types';
import React from 'react';
import PhaseType from 'types/phase';
import { deriveStatusName } from '../../../../utils';

export const phase_canceled = ({ phase: { source, workroom_name: workroom = '' } = {},
                                 event: { kind, data: { from_status, who, reason } } },
) => <div className={kind}>
  The phase was canceled due to {who === 'Duplicate' ? 'SPIG ' : `${who} `}
  while in the {deriveStatusName(from_status, { source, workroom })} status.
  {reason && `Reason: ${reason}`}
</div>;

phase_canceled.propTypes = {
  event: PropTypes.shape({
    kind: PropTypes.string.isRequired,
    data: PropTypes.shape({
      from_status: PropTypes.string.isRequired,
      who: PropTypes.string.isRequired,
      reason: PropTypes.string,
    }).isRequired,
  }).isRequired,
  phase: PhaseType,
};



// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/phaseEvents/phase_canceled.jsx